import * as appFunc from "./AppUtils";
/* =====================================
   D E F I N I T I O N
   ===================================== */

/* const severitiesLevel
 * defines logging level
*/

export const severitiesLevel = appFunc.appEnum.createEnum([
    "PRINT_INFO",
    "PRINT_LOG",
    "PRINT_WARNING",
    "PRINT_ERROR",
    "PRINT_INVALID"
]);

let severitiesStored = severitiesLevel.PRINT_INVALID;

/* =====================================
   F U N C T I O N S
   ===================================== */

/* Function: setLoggingSeverities(severities)
   Info: Defines the type of log to be printed.
   Returns: void
*/
export function setSeverities(severities)
{
    severitiesStored = severities;
}

/* Function: dbprint(severities, printHeader, printContent)
   Info: Prints log to console based on the set severities and above
   * severities: severities of log to be printed
   * printHeader: log header (__func__)
   * printContent: content to be printed
   Returns: void
*/
export function dbprint(severities, printHeader, printContent)
{
    if (severities >= severitiesStored && severities < severitiesLevel.PRINT_INVALID)
    {
        switch(severities)
        {
            case severitiesLevel.PRINT_INFO:
                console.info(`[INFO][${printHeader}] ${printContent}`);
                break;
            case severitiesLevel.PRINT_LOG:
                console.log(`[LOG][${printHeader}] ${printContent}`);
                break;
            case severitiesLevel.PRINT_WARNING:
                console.warn(`[WARN][${printHeader}] ${printContent}`);
                break;
            default:
                console.error(`[ERR][${printHeader}] ${printContent}`);
                break;
        }
    }
    else
    {
        // DO NOTHING, ONLY PRINT IS SEVERITIES IS VALID
    }
}